import { useRouter } from "next/router";
import ChatwootLoader from "./ChatwootLoader";

export default function ContactUs() {
	const { locale } = useRouter();

	return <ChatwootLoader autoOpen={false} locale={locale || "en"} settings={{ position: "right" }} />;
}
